var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255.999,
    height: 255.999,
    viewBox: "0 0 255.999 255.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__cls-2{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_28181",
    "data-name": "Group 28181",
    transform: "translate(2174 18304)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__XMLID_5_",
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#0e3158",
    transform: "translate(-2174 -18304)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_28180",
    "data-name": "Group 28180",
    transform: "translate(-498 -23.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10315",
    d: "m23.217 35.712 12.494-7.18 1.676 2.9 46.04-26.568-3.365-1.935L76.683.967 75.007 0 0 43.328v1.935L21.541 32.81z",
    className: "prefix__cls-2",
    "data-name": "Path 10315",
    transform: "translate(-1623 -18238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10316",
    d: "M23.217 59.361 59.3 38.514l1.69 2.929 46.04-26.569-3.365-1.962-3.379-1.935-1.69-.967L0 66.936v1.935l21.541-12.454z",
    className: "prefix__cls-2",
    "data-name": "Path 10316",
    transform: "translate(-1623 -18234.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10317",
    d: "M23.217 71.19 71.1 43.531l1.69 2.9 46.04-26.6-3.379-1.894-3.365-1.976-1.694-.961L0 78.739v1.976l21.541-12.454z",
    className: "prefix__cls-2",
    "data-name": "Path 10317",
    transform: "translate(-1623 -18232.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10318",
    d: "M23.217 82.989 83.236 48.34l1.69 2.9 45.7-26.378-3.38-1.962-3.365-1.935-1.69-.965L0 90.565V92.5l21.541-12.454z",
    className: "prefix__cls-2",
    "data-name": "Path 10318",
    transform: "translate(-1623 -18230.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10319",
    d: "M23.217 94.778 95.036 53.33l1.69 2.943 45.7-26.406-3.379-1.948-3.365-1.962-1.69-.967L0 102.368v1.932l21.541-12.424z",
    className: "prefix__cls-2",
    "data-name": "Path 10319",
    transform: "translate(-1623 -18228.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10320",
    d: "m147.479 30.985-1.69-.995L0 114.194v1.935L21.541 103.7l1.676 2.9 71.819-41.443 1.69 2.9L150 37.32v-4.864z",
    className: "prefix__cls-2",
    "data-name": "Path 10320",
    transform: "translate(-1623 -18227.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10321",
    d: "m7.219 121.419 12.081-6.962 1.676 2.9 71.7-41.38 1.69 2.929 53.615-30.956v-9.74L5.57 120.452z",
    className: "prefix__cls-2",
    "data-name": "Path 10321",
    transform: "translate(-1620.981 -18224.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10322",
    d: "m89.537 85.989 1.69 2.929 53.615-30.956V48.22L14.23 123.622l1.676.981 12.263-7.085 1.69 2.929",
    className: "prefix__cls-2",
    "data-name": "Path 10322",
    transform: "translate(-1617.841 -18220.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10323",
    d: "m24.577 127.808 12.262-7.108 1.69 2.929 47.879-27.65 1.69 2.929 53.615-30.956V58.21L22.86 126.813z",
    className: "prefix__cls-2",
    "data-name": "Path 10323",
    transform: "translate(-1614.713 -18216.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10324",
    d: "m33.23 130.991 12.263-7.085 1.69 2.9 36.08-20.819 1.69 2.9 53.615-30.97v-9.7L31.54 130.024z",
    className: "prefix__cls-2",
    "data-name": "Path 10324",
    transform: "translate(-1611.566 -18213.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10325",
    d: "m40.2 133.2 1.69.967 12.3-7.085 1.649 2.929 24.28-14.048 1.69 2.943 53.615-30.97V78.21z",
    className: "prefix__cls-2",
    "data-name": "Path 10325",
    transform: "translate(-1608.427 -18209.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10326",
    d: "m50.55 137.38 12.263-7.126L64.5 133.2l12.481-7.249 1.69 2.943 53.615-30.943V88.22L48.86 136.412z",
    className: "prefix__cls-2",
    "data-name": "Path 10326",
    transform: "translate(-1605.287 -18206.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10327",
    d: "m95.227 9.868-3.366-1.935L88.482 6l-1.676-1.01L0 55.117v1.935l21.541-12.413 1.676 2.9 24.294-14.02 1.717 2.943z",
    className: "prefix__cls-2",
    "data-name": "Path 10327",
    transform: "translate(-1623 -18236.189)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRen);
export default __webpack_public_path__ + "static/media/ren.dc2ec752fd6da62a065793504c5320f6.svg";
export { ForwardRef as ReactComponent };